(function () {
  'use strict';

  var CHECK_INTERVAL = 500;
  var MAX_ATTEMPTS = 30;
  var attempts = 0;
  var timer = null;
  var observer = null;

  /* ---------- Yotpo lookups ---------- */

  function getYotpoWidget() {
    return document.querySelector('.yotpo-widget-loyalty-spotlight');
  }

  function getYotpoCTA() {
    return document.querySelector('.yotpo-widget-spotlight-cta');
  }

  function getPointsElement() {
    return document.querySelector('.yotpo-spotlight-cta-points');
  }

  function getPoints() {
    var el = getPointsElement();
    if (!el) return '';
    var points = el.getAttribute('data-original-balance') || el.textContent;
    return points ? points.trim() : '';
  }

  /* ---------- State detection ----------
     NOTE: the not-joined selectors below are unverified against
     Moral Code's real signup DOM. If a logged-in, not-joined test
     account shows "Sign In" instead of "Join Now", check these first. */

  function isNotJoined() {
    var widget = getYotpoWidget();
    if (!widget) return false;
    return !!(
      widget.querySelector('.yotpo-spotlight-drawer__content--signup') &&
      widget.querySelector('.yotpo-spotlight__signup-join-button')
    );
  }

  function isJoinedMember() {
    // A member can have 0 points, so never use points > 0 as the test.
    return !!getPointsElement() && !isNotJoined();
  }

  function isLoggedOut() {
    return !getPointsElement() && !isNotJoined();
  }

  /* ---------- Update button ---------- */

  function updateCTA(button) {
    if (!button) return;

    var label = button.querySelector('.mc-rewards-floating__label');
    var text = button.querySelector('.mc-rewards-floating__text');
    var pointsBadge = button.querySelector('.mc-rewards-floating__points');
    if (!label || !text || !pointsBadge) return;

    function setLabel(value) {
      label.textContent = value;
      label.hidden = !value;
    }

    if (isNotJoined()) {
      button.classList.remove('is-logged-in');
      button.classList.add('is-not-joined');
      setLabel('Rewards');
      text.textContent = 'Join Now';
      pointsBadge.textContent = '';
      button.setAttribute('aria-label', 'Join rewards program');
      return;
    }

    if (isJoinedMember()) {
      button.classList.add('is-logged-in');
      button.classList.remove('is-not-joined');
      setLabel('');
      text.textContent = 'My Rewards';
      pointsBadge.textContent = getPoints();
      button.setAttribute('aria-label', 'View my rewards');
      return;
    }

    if (!isLoggedOut()) {
      console.warn('[mc-rewards] Unrecognized Yotpo state, falling back to "Sign In".');
    }

    button.classList.remove('is-logged-in');
    button.classList.remove('is-not-joined');
    setLabel('Rewards');
    text.textContent = 'Sign In';
    pointsBadge.textContent = '';
    button.setAttribute('aria-label', 'Sign in to see your rewards');
  }

  /* ---------- Open Yotpo (never clicks the Join button) ---------- */

  function openYotpo() {
    var cta = getYotpoCTA();

    if (cta) {
      var btn = cta.querySelector('.yotpo-widget-spotlight-cta__button');
      (btn || cta).click();
      return;
    }

    var widget = getYotpoWidget();
    if (widget) {
      if (widget.querySelector('.yotpo-spotlight-drawer')) return;
      console.warn('[mc-rewards] No drawer found, clicking the widget root as fallback.');
      widget.click();
      return;
    }

    console.warn('[mc-rewards] Neither the spotlight CTA nor the loyalty widget was found.');
  }

  /* ---------- Create button ---------- */

  function createCTA() {
    var existing = document.querySelector('.mc-rewards-floating');
    if (existing) {
      updateCTA(existing);
      return existing;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mc-rewards-floating';
    button.setAttribute('aria-label', 'Open rewards');

    button.innerHTML =
      '<span class="mc-rewards-floating__icon">✦</span>' +
      '<span class="mc-rewards-floating__content">' +
        '<span class="mc-rewards-floating__label">Rewards</span>' +
        '<span class="mc-rewards-floating__title">' +
          '<span class="mc-rewards-floating__text">Sign In</span>' +
          '<span class="mc-rewards-floating__points"></span>' +
        '</span>' +
      '</span>' +
      '<span class="mc-rewards-floating__arrow">' +
        '<svg viewBox="0 0 16 16" aria-hidden="true">' +
          '<path d="M5.5 2.5 11 8l-5.5 5.5 1.1 1.1L13.2 8 6.6 1.4z"></path>' +
        '</svg>' +
      '</span>';

    document.body.appendChild(button);
    updateCTA(button);

    button.addEventListener('click', openYotpo);

    document.body.classList.add('mc-rewards-ready');

    // Keep the button in sync when Yotpo changes (join, points update, async load).
    var target = getYotpoWidget() || getYotpoCTA();
    if (target && !observer) {
      observer = new MutationObserver(function () {
        updateCTA(button);
      });
      observer.observe(target, { childList: true, subtree: true, characterData: true });
    }

    return button;
  }

  /* ---------- Init ---------- */

  function initialize() {
    if (!getYotpoCTA()) return false;
    createCTA();
    return true;
  }

  function start() {
    if (initialize()) return;

    timer = setInterval(function () {
      attempts++;

      if (initialize()) {
        clearInterval(timer);
        timer = null;
        return;
      }

      if (attempts >= MAX_ATTEMPTS) {
        clearInterval(timer);
        timer = null;
        console.warn(
          '[mc-rewards] Gave up waiting for .yotpo-widget-spotlight-cta after ' +
          (MAX_ATTEMPTS * CHECK_INTERVAL / 1000) + 's. Is the Yotpo spotlight block on this page?'
        );
      }
    }, CHECK_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
